/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserProjectsQuery } from '../../models/get-user-projects-query';
import { GetUserProjectsQueryResult } from '../../models/get-user-projects-query-result';

export interface ApiProjectGetUserProjectsPost$Plain$Params {
      body?: GetUserProjectsQuery
}

export function apiProjectGetUserProjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetUserProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetUserProjectsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserProjectsQueryResult>;
    })
  );
}

apiProjectGetUserProjectsPost$Plain.PATH = '/api/Project/GetUserProjects';
